import React from 'react';
import PropTypes from 'prop-types';

import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import './Slider.scss';

const _Slider = ({
  changeHandler,
  defaultValue,
  max,
  min,
  step,
  value,
  vertical,
}) => {
  const sliderStyles = {
    trackStyle: { backgroundColor: '#214C6C' },
    handleStyle: {
      borderColor: '#214C6C',
      backgroundColor: '#f8f8f8',
    },
    railStyle: { backgroundColor: '#e8e8e8' },
  };

  return (
    <Slider
      value={value}
      min={min || 0}
      max={max || 10}
      step={step}
      onChange={changeHandler}
      defaultValue={defaultValue || 0}
      vertical={vertical || false}
      className="slider"
      {...sliderStyles}
    />
  );
};

_Slider.propTypes = {
  changeHandler: PropTypes.func,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  step: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  vertical: PropTypes.bool,
};

export default _Slider;
